import { render, staticRenderFns } from "./AddAttributeGroupMenu.vue?vue&type=template&id=f6d510aa&scoped=true&"
import script from "./AddAttributeGroupMenu.vue?vue&type=script&lang=ts&"
export * from "./AddAttributeGroupMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d510aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem})
